import { Box } from "theme-ui";
import { OverlayHeaderDesktop } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Box,
  OverlayHeaderDesktop,
  React
};